import { memo } from 'react';

import dynamic from 'next/dynamic';

import { Builder } from '@builder.io/react';
import { uiImages } from '@/react/components/content/registry/data';

/**
 * The Breadcrumbs component is used to display a list of breadcrumbs.
 */
const register = (): void => {
  Builder.registerComponent(memo(dynamic(() => import('./Breadcrumbs'))), {
    name: 'Breadcrumbs',
    inputs: [
      {
        name: 'breadcrumbs',
        type: 'list',
        subFields: [
          { name: 'link', type: 'string' },
          { name: 'displayValue', type: 'string' }
        ]
      },
      {
        name: 'variant',
        type: 'string',
        enum: ['base', 'link', 'text', 'text-underline'],
        defaultValue: 'text'
      }
    ],
    image: uiImages.cubeImage
  });
};

export default register;
